export default "__VITE_ASSET__CNDlv3vE__"